/**
 * Portfolio IDs that should not display performance charts.
 * These portfolios will show a message directing users to external sources.
 */
const HIDDEN_PERFORMANCE_PORTFOLIO_IDS: number[] = [51, 98];

/**
 * Basket IDs that should not display performance charts.
 */
const HIDDEN_PERFORMANCE_BASKET_IDS: number[] = [132, 133, 134, 135, 136, 137, 138, 139];

/**
 * Check if a portfolio should hide its performance chart
 */
export const shouldHidePerformanceChart = (portfolioId: number): boolean => {
  return HIDDEN_PERFORMANCE_PORTFOLIO_IDS.includes(portfolioId);
};

/**
 * Check if a basket should hide its performance chart
 */
export const shouldHideBasketPerformanceChart = (basketId: number): boolean => {
  return HIDDEN_PERFORMANCE_BASKET_IDS.includes(basketId);
};

/**
 * Message to display when performance is hidden
 */
export const PERFORMANCE_UNAVAILABLE_MESSAGE =
  "Performance data is not available. Please visit citrindex.com";
